export default {
  "b2b.zadosti-odbaveni-grid.action-filter": "Filtrovat",
  "b2b.zadosti-odbaveni-grid.dialogAccept.title": "Potvrzení žádosti",
  "b2b.zadosti-odbaveni-grid.dialogDecline.title": "Zamítnutí žádosti",
  "b2b.zadosti-odbaveni-grid.filter.dateFrom.label": "Datum od",
  "b2b.zadosti-odbaveni-grid.filter.dateTo.label": "Datum do",
  "b2b.zadosti-odbaveni-grid.filter.zdroj.label": "Zdroj žádosti",
  "b2b.zadosti-odbaveni-grid.label": "Odbavení žádostí",
  "b2b.zadosti-odbaveni-grid.toolbarItemAccept.label": "POTVRDIT",
  "b2b.zadosti-odbaveni-grid.toolbarItemDecline.label": "ZAMÍTNOUT"
};
